import React, { useState, useEffect } from 'react';
import { CardMedia } from '@mui/material';
import {kbUserDataLoaded, RAW_FILES_URL} from "../utils";

const CACHE_REVISION_KEY = 'kbImageCacheRevision';

export function invalidateKBImageCache() {
    const newRevision = Math.random().toString();
    sessionStorage.setItem(CACHE_REVISION_KEY, newRevision);
    // Preheat the cache for the next refresh
    preheatCache(newRevision);
}

export const getKBImage = (id) => {
    id = id || kbUserDataLoaded?.kbId
    const cacheRevision = sessionStorage.getItem(CACHE_REVISION_KEY) || Math.random().toString();
    // Ensure the cache revision is stored for future use
    sessionStorage.setItem(CACHE_REVISION_KEY, cacheRevision);
    return `${RAW_FILES_URL}/kb-image/${id}.png?v=` + cacheRevision;
}

function preheatCache(newRevision) {
    // This function can be expanded to preheat the cache more effectively
    // For now, it just ensures the new revision is stored in local storage
    sessionStorage.setItem(CACHE_REVISION_KEY, newRevision);
}

export const KBImageComponent = ({ id, alt = '', folder = 'kb-image', fileData, height = 256, width = 256, style, noDefault = false }) => {
    const imageUrl = folder === 'kb-image'
        ? getKBImage(id)
        : `${RAW_FILES_URL}/app-image/${id}.png`;

    const [showDefaultIcon, setShowDefaultIcon] = useState(false);
    const defaultUrl = `https://openkbs.com/logo512.png`;

    // Ensure cache revision is initialized on component mount
    useEffect(() => {
        if (!sessionStorage.getItem(CACHE_REVISION_KEY)) {
            invalidateKBImageCache();
        }
    }, []);

    return (
        <CardMedia
            component="img"
            alt={alt}
            style={{ ...style, height, width, objectFit: 'cover' }}
            image={fileData ? fileData : (showDefaultIcon ? defaultUrl : imageUrl)}
            title={alt}
            onError={() => setShowDefaultIcon(true)}
        />
    );
};